import { getConfig } from '@constants';

import { EStatEventType, EAppId, ESubProject } from '../../../../enums';
import { StatInstanceBase } from '../../StatInstanceBase';

import { IStatAppleStoreOpenParams } from './types';

export class StatAppStoreApi extends StatInstanceBase {

	private getAppId(from: ESubProject): EAppId {
		const { isMobile } = getConfig();

		if (from === ESubProject.BOOM) {
			return isMobile ? EAppId.WEB_MOBILE : EAppId.WEB;
		}
		if (from === ESubProject.SHARE) {
			return isMobile ? EAppId.SHARE_MOBILE : EAppId.SHARE;
		}

		return EAppId.UNSET;
	}

	storeOpen({ from, store }: IStatAppleStoreOpenParams) {
		void this.sendStat({
			action: EStatEventType.OPEN_STORE,
			appId: this.getAppId(from),

			data0: store,
		});
	}

}
